import React, { useMemo } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import { blue } from '@mui/material/colors';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { DEFAULT_SHORTCUTS } from 'shared/mui/DatePicker/components/DatePickerShortcuts/constants/shortcuts';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import { Typography } from 'shared/mui/Typography';
import { truncateString } from 'utils/truncateString';

import {
  ActionStyled,
  ContentStyled,
  SubContentStyled,
  WrapperStyled,
} from './FilterFavoritePopoverItem.styled';

type Props = {
  favorite?: boolean;
  period: string;
  name: string;
  onRemove: (name: string) => void;
  onClick: (name: string) => void;
};

export const FilterFavoritePopoverItem: React.FC<Props> = ({
  favorite,
  period,
  name,
  onRemove,
  onClick: onClickProp,
}) => {
  const translate = useTypedTranslate();

  const periodName = useMemo(() => {
    return (
      DEFAULT_SHORTCUTS(DEFAULT_TIMEZONE)
        .flat(1)
        .find((shortcut) => shortcut?.alias === period)?.label || ''
    );
  }, [period]);

  const onRemoveHandler: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    onRemove(name);
  };

  return (
    <WrapperStyled>
      <ContentStyled
        onClick={() => {
          onClickProp(name);
        }}
      >
        <Typography>{truncateString(name || '', 33)}</Typography>
        <SubContentStyled>
          {favorite && (
            <Typography color={blue[700]} variant="caption">
              {translate('app.filter.fav')}
            </Typography>
          )}
          {favorite && <Typography variant="caption">|</Typography>}
          <Typography variant="caption">{periodName ? translate(periodName) : ''}</Typography>
        </SubContentStyled>
      </ContentStyled>
      <ActionStyled>
        <IconButton onClick={onRemoveHandler}>
          <DeleteIcon />
        </IconButton>
      </ActionStyled>
    </WrapperStyled>
  );
};
